module.exports = __webpack_public_path__ + "img/ic-shipment.4d9044ca.svg";